import React, { useState, useEffect } from "react";



import { Box, Typography, Divider, List, ListItem, ListItemIcon, ListItemText, CardMedia, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppsIcon from "@mui/icons-material/Apps";


const HomeScreen = () => {



  // State to track the selected URL for iframe
  const [selectedUrl, setSelectedUrl] = useState("");

  // const baseUrl = "http://localhost:3002/";

   const baseUrl = "https://nir.goqii.com/";

  // const launchUrl = "http://localhost:3002/?screen=pwa_luanch&encUserId=ekc3QmpBZUZTREJieGZyMDl2Yk9rdz09&jwtToken=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMDAwMDAyNjg0NjU5OmMzTmpUMVJPTjJVelJ6STVkVlZTT1VKQlNEaEdkejA5OmVkZ2UiLCJpYXQiOjE3MzQ5Mzc5NzQsImV4cCI6MTc2NDkzNzk3NH0.RxJgl0FTLzRhjdO4SWa3eGSTyAzJ1oY8UkJvgwuu4DA";
  const launchUrl = "https://nir.goqii.com/?screen=pwa_luanch&encUserId=ekc3QmpBZUZTREJieGZyMDl2Yk9rdz09&jwtToken=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMDAwMDAyNjg0NjU5OmMzTmpUMVJPTjJVelJ6STVkVlZTT1VKQlNEaEdkejA5OmVkZ2UiLCJpYXQiOjE3MzQ5Mzc5NzQsImV4cCI6MTc2NDkzNzk3NH0.RxJgl0FTLzRhjdO4SWa3eGSTyAzJ1oY8UkJvgwuu4DA";

  // Handle browser navigation
  // Replace the existing useEffect with this:
useEffect(() => {
  const handleBackButton = (e) => {
    // Prevent default navigation
    e.preventDefault();
    // Navigate directly to launch URL
    window.location.replace(launchUrl);
  };

  // Add the back button listener
  window.addEventListener('popstate', handleBackButton);

  // Set initial history state without causing navigation
  window.history.replaceState({ page: 'home' }, '', window.location.pathname);

  return () => {
    window.removeEventListener('popstate', handleBackButton);
  };
}, []);
  
    const entryPoints = [
      { label: "Doctor Consults", image: "/DOCTOR_TELE_CONSULTS.png", description: "Consult top doctors online for medical advice anytime, anywhere.", url: `${baseUrl}?screen=doctor`, bgColor: "#FFE5D9" },
      { label: "Health Blogs", image: "/HEALTH_BLOGS.png", description: "Explore expert health tips, wellness articles, and fitness insights.", url: `${baseUrl}?screen=healthyreads`, bgColor: "#FFF3D9" },
      { label: "Health Store", image: "/HEALTH_STORE.png", description: "Shop health essentials, supplements, and wellness products.", url: `${baseUrl}?screen=store_home_page`, bgColor: "#E0F7F0" },
      { label: "Live Coaching", image: "/LIVE_VIDEO_COACHING.png", description: "Join interactive fitness and wellness sessions with experts.", url: `${baseUrl}?screen=playscreen`, bgColor: "#E5EEFF" },
      { label: "Loyalty Rewards", image: "/LOYALTY_REWARDS.png", description: "Earn points and redeem exciting rewards for your healthy lifestyle.", url: `${baseUrl}?screen=goqiicash`, bgColor: "#FFE5EC" },
      { label: "Health Coaching", image: "/PERSONAL_HEALTH_COACHING.png", description: "Get personalized guidance from certified health coaches.", url: `${baseUrl}?screen=coaching`, bgColor: "#FFE5F6" },
    ];
  const shortenedDescriptions = [
    "Consult doctors online anytime for medical advice.",
    "Read health tips, wellness articles, and fitness guides.",
    "Shop health products, supplements, and wellness essentials.",
    "Join live fitness and wellness sessions with experts.",
    "Earn rewards for staying healthy and redeem exciting offers.",
    "Get personalized health coaching from certified experts."
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        minHeight: "100vh",
        // backgroundColor: "#f4f6f8",
        overflow: "hidden",
        backgroundImage: "url(https://appcdn.goqii.com/storeimg/82809_1733314164.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
    
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 3,
          backgroundColor: "rgba(240, 240, 240, 0.6)",
          backdropFilter: "blur(4px)",
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "375px", // Mobile width
            height: "667px", // Mobile height
            backgroundColor: "#fff",
            borderRadius: "24px",
            overflow: "hidden",
            position: "relative",
            border: "2px solid #ccc",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Status Bar */}
          {/* <Box
            sx={{
              width: "100%",
              height: "24px",
              backgroundColor: "#000",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 8px",
              fontSize: "12px",
            }}
          > */}
            {/* add system time with realtime time running in am/pm format */}
            {/* <span>{new Date().toLocaleTimeString(undefined, { timeStyle: "short" })}</span>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <span>📶</span>
              <span style={{ marginLeft: "4px" }}>🔋</span>
            </Box>
          </Box> */}

          {/* Main Content Area */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {selectedUrl ? (
              <iframe
                src={selectedUrl}
                title="GOQii Content"
                style={{
                  width: "100%",  // ✅ No extra width
                  height: "100%", // ✅ No extra height
                  border: "none",
                  zoom: "0.8", // ✅ Scales content without changing height
                  display: "block",
                }}
              />
            ) : (
              <Box sx={{
                p: 0,
                height: '100%',
                overflow: 'auto',
                backgroundColor: 'rgba(255, 152, 0, 0.11)',
              }}>
                <Typography variant="h5" sx={{
                  mb: 2,
                  mt: 2,
                  textAlign: 'center',
                  color: '#771615',
                  fontWeight: 'bold',
                  fontSize: { xs: '1rem', sm: '1.2rem' }
                }}>
                  {/* Here is what you get with NIR EDGE */}
                  Explore Your NIR EDGE Benefits
                </Typography>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(2, 1fr)'
                  },
                  gap: { xs: 1, sm: 1.5 },
                  p: { xs: 1, sm: 1 },
                  maxHeight: { xs: 'calc(100vh - 120px)', sm: 'auto' },
                  overflowY: 'auto'
                }}>
                  {entryPoints.map((entry, index) => (
                    <Paper
                      key={index}
                      elevation={0}
                      onClick={() => {
                        // Push new state before setting URL
                        window.history.pushState({ page: 'content' }, '', window.location.pathname);
                        setSelectedUrl(entry.url);
                      }}
                      sx={{
                        cursor: 'pointer',
                        borderRadius: '20px',
                        height: '180px',
                        background: `linear-gradient(180deg, ${entry.bgColor} 30%, rgba(255,255,255,0.9) 100%)`,
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 8px #771615',
                        },
                        boxShadow: '0 2px 4px #771615',
                      }}
                    >
                      <Box sx={{
                        p: { xs: 1.5, sm: 2 },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: 1.5,
                        alignItems: 'center',
                        height: '100%',
                        // border: '1px solid #000',
                      }}>
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          // border: '1px solid #000',
                          gap: 1,
                          mb: 1
                        }}>
                          <CardMedia
                            component="img"
                            image={entry.image}
                            alt={entry.label}
                            sx={{
                              width: { xs: '52px', sm: '56px' },
                              height: { xs: '52px', sm: '56px' },
                              objectFit: 'contain'
                            }}
                          />
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: 600,
                              color: '#333',
                              flex: 1,
                              fontSize: { xs: '0.5rem', sm: '0.875rem' },
                              textAlign: 'center'
                            }}
                          >
                            {entry.label}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#666',
                            lineHeight: 1.3,
                            fontSize: { xs: '0.5rem', sm: '0.6rem' },
                            textAlign: 'center',
                            mt: 0.5
                          }}
                        >
                          {shortenedDescriptions[index]}
                        </Typography>
                      </Box>
                    </Paper>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
export default HomeScreen;